module.exports = __webpack_public_path__ + "static/media/seller_suite-2.203e86ad.jpg";